<template>

    <div>

  
      <panel-navigation>
  
        <div class="float-right ml-5 -mt-1">
          
        </div>
  
        <div class="container flex flex-row items-center justify-between">
            <h1 class="text-lg font-semibold mt-5">DataShake Logs</h1>
            
        </div>
  
        <hr class="border-b border-gray-100 mb-3">
  
        <v-skeleton-loader v-if="!listings" type="article, article, article"></v-skeleton-loader>

  
        <template v-else>
            <div class="dashboard-box">
            <v-card
              class="pa-2"
              tile
            >
              <div class="p-3">
                
                <div class="flex flex-wrap items-center justify-between">
                  <div class="w-full md:w-1/3 pr-3">
                    <v-text-field
                      v-model="search"
                      clearable
                      outlined
                      dense
                      hide-details
                      prepend-inner-icon="mdi-magnify"
                      label="Search name, job-id, url,email,agency name, business name"
                      @input="handleSearch"
                    ></v-text-field>
                  </div>

                  <!-- <div class="w-full md:w-1/3 pl-3">
                    <v-select
                      v-model="selectedSubscriptionStatus"
                      :items="subscriptionStatuses"
                      label="Filter by Subscription Status"
                      clearable
                      dense
                      outlined
                      hide-details
                      @change="handleSearch"
                    ></v-select>
                  </div> -->
                </div>

                <br clear="all" />
                
                <div  v-if="!fetchingListings && listings.length >= 0" class="overflow-x-hidden" >
                  <div class="p-3 custom-data-table">
                    <div style="clear: both; padding-top: 0px;">
                      <v-data-table
                        :headers="headers"
                        :items="listings"
                        :items-per-page="50"
                        class="rg-datatable elevation-1"
                        mobile-breakpoint="10"
                      >

                        <template v-slot:item.job_id="{ item }">
                          <a :href="'https://app.datashake.com/profiles/'+item.job_id" target="_blank">
                              <strong>{{ item.job_id }}</strong>
                          </a>
                            
                        </template>

                        <template v-slot:item.place_id="{ item }">
                          <span style="">{{ item.place_id ? item.place_id : '-' }}</span>
                        </template>

                        <template v-slot:item.email="{ item }">
                          <span>{{ item.user && item.user.email ? item.user.email : '-' }}</span>
                        </template>

                        <template v-slot:item.agency="{ item }">
                          <span>{{ item.user.parent && item.user.parent.company_type === 'agency' ? item.user.parent.email : '-' }}</span>   
                        </template>

                        <template v-slot:item.agency_name="{ item }">
                          <span>{{ item.user.parent && item.user.parent.company_type === 'agency' ? item.user.parent.company_name : '-' }}</span>   
                        </template>
                        
                        <template v-slot:item.business="{ item }">
                          <span>{{ item.user.parent && item.user.parent.company_type === 'business' ? item.user.parent.email : '-' }}</span>
                        </template>

                        <template v-slot:item.business_name="{ item }">
                          <span>{{ item.user.parent && item.user.parent.company_type === 'business' ? item.user.parent.company_name : '-' }}</span>   
                        </template>

                        <template v-slot:item.source="{ item }">
                          <strong>{{ getDomainFromUrl(item.url) }}</strong>
                        </template>

                        <template v-slot:item.name="{ item }">
                          <strong >{{ item.name ? item.name : '-' }}</strong>
                        </template>

                        <template v-slot:item.last_crawl="{ item }">
                          <span >{{ item.last_crawl ? formatDate(item.last_crawl) : '-' }}</span>
                        </template>

                        <template v-slot:item.crawl_status="{ item }">
                            <v-chip 
                              small
                              color="blue lighten-5"
                              text-color="blue lighten-1"
                              style="cursor: pointer;"  
                              >
                              {{ item.crawl_status  }}
                            </v-chip>
                        </template>

                        <template v-slot:item.percentage_complete="{ item }">
                          <span>{{ item.percentage_complete ? Math.floor(item.percentage_complete) + '%' : '-' }}</span>
                        </template>



                        <template v-slot:item.created_at="{ item }">
                          <span >{{ formatDate(item.created_at) }}</span>
                        </template>

                        <template v-slot:item.reviews_scrape_frequency="{ item }">
                          <span>{{ item.user ? item.user.reviews_scrape_frequency : '-' }}</span>
                      </template>


                      <template v-slot:item.next_run="{ item }">
                        <span>{{ getNextRunDate(item.last_crawl, item.user ? item.user.reviews_scrape_frequency : 0) }}</span>
                      </template>
                        <template v-slot:item.url="{ item }">
                            <a :href="item.url" target="_blank">
                                <span>{{ item.url }}</span>
                            </a>
                        </template>
                      </v-data-table>

                    </div>
                </div>
               </div>
              
               <div v-if="!fetchingListings && listings.length > 0"  class="mt-5">
                        <v-pagination
                            v-model="currentPage"
                            :length="totalPages"
                            :total-visible="9"
                            color="primary"
                            rounded="circle"
                            @input="getSearch"
                        ></v-pagination>
                </div>
            </div>
            </v-card>
          </div>

        </template>
      </panel-navigation>
    </div>
  
    
  </template>
  
  <script>
  import axios from 'axios'
  import { mapState } from 'vuex'
  import PanelNavigation from '@/components/PanelNavigation.vue'
  import MenuUserActions from '@/components/menus/menuUserActions.vue'
  import moment from 'moment'
  
  export default {
    metaInfo () {
      return {
        title: "Datashake Logs | " + this.$appName
      }
    },
    components: {
      PanelNavigation,
      MenuUserActions,
    },
    data() {
      return {
        listings :null,
        currentPage: 1,
        totalItems: 0,
        perPage: 50,
        totalPages: 0,
        fetchingListings: false,
        headers: [
            { text: 'Datashake Job id', value: 'job_id', sortable: false },
            { text: 'User Email', value: 'email', sortable: false },
            { text: 'Agency', value: 'agency', sortable: false },
            { text: 'Agency Name', value: 'agency_name', sortable: false },
            { text: 'Business', value: 'business', sortable: false },
            { text: 'Business Name', value: 'business_name', sortable: false },
            { text: 'Place id', value: 'place_id', sortable: false },
            { text: 'Source', value: 'source', sortable: false },
            { text: 'Name', value: 'name', sortable: false },
            { text: 'Last Crawl', value: 'last_crawl', sortable: true },
            { text: 'Crawl Status', value: 'crawl_status', sortable: false },
            { text: 'Percentage', value: 'percentage_complete', sortable: false },
            { text: 'Created', value: 'created_at', sortable: true  },
            { text: 'Frequency of Review Checks', value: 'reviews_scrape_frequency', sortable: false }, 
            { text: 'Next Run', value: 'next_run', sortable: false },
            { text: 'Url', value: 'url', sortable: false },
          ],
          search:"",
      }
    },
    computed: {
      ...mapState({
        me: state => state.me.me
      }),
      
    },
    methods: {

        formatDate: function(date) {
            return moment(String(date)).format('MM/DD/YYYY')
        },
        getNextRunDate: function(lastCrawl, frequency) {
          if (lastCrawl && frequency) {
            const nextRun = moment(lastCrawl).add(frequency, 'days');
            return nextRun.format('MM/DD/YYYY');
          }
          return '-'; 
        },
        getDomainFromUrl(url) {
          try {
            const parsedUrl = new URL(url);
            let domain =  parsedUrl.hostname; 
            if (domain.startsWith('www.')) {
              domain = domain.substring(4);
            }
            return domain
          } catch (e) {
            return '-'; // Return a hyphen if URL is invalid
          }
        },
        async getSearch(){
            this.fetchingListings = true;
            const params = {
                    page: this.currentPage,  
                    perPage: this.perPage,
                    search: this.search,
                    // subscriptionStatus: this.selectedSubscriptionStatus  
                };

                let response = await axios.get(`${process.env.VUE_APP_API_ENDPOINT}/me/listings/admin`, {
                    headers: {
                        'Authorization': 'Bearer ' + this.$store.state.auth.jwt
                    },
                    params: params 
                });
               
                if (response.status === 200) {
                    this.fetchingListings = false;
                    this.listings = response.data.data;  
                    this.totalItems = response.data.total;  
                    this.totalPages = response.data.last_page;
                }
        },
      handleSearch() {
        this.currentPage = 1;
        this.getSearch();
      }
    },
    mounted() {
        if(this.me.company_type != 'admin'){
          window.location = '/dashboard'
        }
        this.getSearch();
    }
  }
  </script>
  
  <style lang="scss" scoped>
  
  .styled-checkbox {
    position: absolute; // take it out of document flow
    opacity: 0; // hide it
  
    & + label {
      position: relative;
      cursor: pointer;
      padding: 0;
    }
  
    // Box.
    & + label:before {
      content: '';
      margin-right: 0px;
      display: inline-block;
      vertical-align: text-top;
      width: 20px;
      height: 20px;
      background: rgb(228, 228, 228);
    }
  
    // Box hover
    /*&:hover + label:before {
      background: #f35429;
    }*/
    
    // Box focus
    &:focus + label:before {
      
      border-width: 0;
    }
  
    // Box checked
    &:checked + label:before {
      background: #48bb78;
    }
    
    // Disabled state label.
    &:disabled + label {
      color: #b8b8b8;
      cursor: auto;
    }
  
    // Disabled box.
    &:disabled + label:before {
      box-shadow: none;
      background: #ddd;
    }
  
    // Checkmark. Could be replaced with an image
    &:checked + label:after {
      content: '';
      position: absolute;
      left: 5px;
      top: 9px;
      background: white;
      width: 2px;
      height: 2px;
      box-shadow: 
        2px 0 0 white,
        4px 0 0 white,
        4px -2px 0 white,
        4px -4px 0 white,
        4px -6px 0 white,
        4px -8px 0 white;
      transform: rotate(45deg);
    }
  }
  
  .btn-invite {
    background-color: #00ad9e;
  }
  
  table tbody tr {
    transition: all 0.1s linear;
  }
  
  table tbody tr:hover {
    background-color: rgb(245, 245, 245);
  }
  textarea {
        resize: none; 
        font-family: monospace; 
        height: 500px;
    }
    .code-editor {
        background-color: #1e1e1e;
        color: #d4d4d4;
        padding: 10px;
        font-family: Consolas, Courier New, monospace;
        font-size: 14px;
        line-height: 1.5;
        overflow-x: auto;
    }
  </style>
  